// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"68bf2894","584":"15c9e680","732":"6860002b"}[chunkId] + ".chunk.js";
};